import { Image } from '@chakra-ui/react';
import React from 'react';
import footerLogo from '@/assets/oldgill/images/logo.png';

export default function index() {
  return <Image src={footerLogo} minW="165px" minH="50px" pl="2" />;
}
